import { render, staticRenderFns } from "./InviteFriends.vue?vue&type=template&id=26510863&scoped=true"
import script from "./InviteFriends.vue?vue&type=script&lang=js"
export * from "./InviteFriends.vue?vue&type=script&lang=js"
import style0 from "./InviteFriends.vue?vue&type=style&index=0&id=26510863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26510863",
  null
  
)

export default component.exports